import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PodpisInfo } from '../../models/podpis-info';
import { AuthenticationTokenTypeEnum } from '../../enums/authentication-token-type.enum';
import { Beneficjent } from '../../models/beneficjent';

@Injectable()
export class SignatureApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI;

  public getSignatureSettings(): Observable<PodpisInfo> {
    const httpParams = new HttpParams().append(
      'tokenType',
      AuthenticationTokenTypeEnum.CK,
    );
    return this.#httpClient.get<PodpisInfo>(`${this.#apiUrl}/sign/settings`, {
      params: httpParams,
    });
  }

  public sign(signature: string): Observable<Beneficjent> {
    return this.#httpClient.post<Beneficjent>(
      `${this.#apiUrl}/auth/signInSignature`,
      signature,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'text/plain',
        },
      },
    );
  }
}
